import React, { useEffect, useRef, useState } from 'react';
import Stats from 'stats.js';

const StatsMonitor: React.FC = () => {
  const statsRef = useRef<Stats | null>(null);
  const [_, setIsVisible] = useState(false);

  useEffect(() => {
    // Initialize stats
    statsRef.current = new Stats();
    statsRef.current.showPanel(0);
    const statsDom = statsRef.current.dom;

    // Style and scale the stats panel
    statsDom.style.transform = 'scale(2)';
    statsDom.style.transformOrigin = 'top left';
    statsDom.style.position = 'absolute';
    statsDom.style.left = '10px';
    statsDom.style.top = '10px';
    statsDom.style.display = 'none';

    document.body.appendChild(statsDom);

    // Update stats on each animation frame
    const animate = () => {
      statsRef.current?.begin();
      statsRef.current?.end();
      requestAnimationFrame(animate);
    };
    requestAnimationFrame(animate);

    // Event listener to toggle visibility
    const toggleStats = () => {
        setIsVisible((prevVisible) => {
          const newVisible = !prevVisible;
          statsDom.style.display = newVisible ? 'block' : 'none';
          return newVisible;
        });
      };

    document.addEventListener('show-stats', toggleStats);

    // Cleanup
    return () => {
        document.removeEventListener('show-stats', toggleStats);
      if (statsRef.current) {
        document.body.removeChild(statsRef.current.dom);
      }
    };
  }, []);

  return null;
};

export default StatsMonitor;
